<template>
  <div>
    <div style="
      display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #ddf1dd;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      "
      v-if="displayStatusLabel === `Fulfilling` || displayStatusLabel === `Receiving` || displayStatusLabel === 'Successful'">
      <!-- <p style="width: 9px;height: 9px;background: #2ca62d;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #2ca62d">{{ displayStatusLabel }}</p>
    </div>
    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #fff2d6;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      " v-if="displayStatusLabel === `AwaitingFulfillment`">
      <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #ffb102">{{ displayStatusLabel }}</p>
    </div>
    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #d1edfc;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      " v-if="
        displayStatusLabel === `New` || displayStatusLabel === `AwaitingPacking` || displayStatusLabel === `Draft`
      ">
      <!-- <p style="width: 9px;height: 9px;background: #41c4fd;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #41c4fd">{{ displayStatusLabel }}</p>
    </div>
    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #418a49;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      "
      v-if="displayStatusLabel === `Complete` || displayStatusLabel === `Active` || displayStatusLabel === `Passed` || displayStatusLabel === `Available` || displayStatusLabel === `Completed`">
      <!-- <p style="width: 9px;height: 9px;background: #134e12;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #fff">{{ displayStatusLabel }}</p>
    </div>
    <div style="
       display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #ff000073;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      " v-if="
        displayStatusLabel === `Canceled` ||
        displayStatusLabel === `Failed` ||
        displayStatusLabel === `Delivered` ||
        displayStatusLabel === `Cancelled` || 
        displayStatusLabel === `Dormant` || 
        displayStatusLabel === `Returned` || 
        displayStatusLabel === `CriticallyOverdue`
      ">
      <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #fff">{{ displayStatusLabel }}</p>
    </div>
   
    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #fff2d6;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      " v-if="
        displayStatusLabel === `AwaitingConfirmation` ||
        displayStatusLabel === `Pending`
      ">
      <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #ffb102">{{ displayStatusLabel }}</p>
    </div>
    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #ffb102;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      "
      v-if="displayStatusLabel === `AwaitingPickup` || displayStatusLabel === `PartiallyPaid` || displayStatusLabel === `Packed` || displayStatusLabel === `Processing` ">
      <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #fff">{{ displayStatusLabel }}</p>
    </div>
    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #0096889e;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      "
      v-if="displayStatusLabel === `Received` || displayStatusLabel === `Paid` || displayStatusLabel === `AwaitingDelivery` || displayStatusLabel === 'Shipped' ">
      <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #fff">{{ displayStatusLabel }}</p>
    </div>
    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #BF83FF;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      " v-if="displayStatusLabel === `Confirmed`">
      <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #fff">{{ displayStatusLabel }}</p>
    </div>
    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #3f51b5;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      " v-if="displayStatusLabel === `Firmed`">
      <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #fff">{{ displayStatusLabel }}</p>
    </div>
    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #795548;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      " v-if="displayStatusLabel === `Expired` || displayStatusLabel === `Overdue` ">
      <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #fff">{{ displayStatusLabel }}</p>
    </div>
    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #87d068;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      " v-if="displayStatusLabel === `Enabled`">
      <!-- <p style="width: 9px;height: 9px;background: #134e12;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #fff">{{ displayStatusLabel }}</p>
    </div>
    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #ff5500;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      " v-if="displayStatusLabel === `Disabled`">
      <!-- <p style="width: 9px;height: 9px;background: red;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #fff">{{ displayStatusLabel }}</p>
    </div>
    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #fff2d6;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      " v-if="displayStatusLabel === `UnApproved` ">
      <!-- <p style="width: 9px;height: 9px;background: #ffb102;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #ffb102">{{ displayStatusLabel }}</p>
    </div>

    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #418a49;
        width: 140px;
        height: 27px;
        border-radius: 5px;
      " v-if="displayStatusLabel === `Approved`">
      <!-- <p style="width: 9px;height: 9px;background: #134e12;margin-top: 5px;border-radius:50%"></p> -->
      <p style="font-size: 12px; color: #fff">{{ displayStatusLabel }}</p>
    </div>

    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #418a49;
        width: 118px;
        height: 27px;
        border-radius: 5px;
      " v-if="displayStatusLabel === true">
      <p style="font-size: 12px; color: #fff">Active</p>
    </div>

    <div style="
        display: flex;
        padding-top: 4px;
        justify-content: space-around;
        background: #ff000073;
        width: 118px;
        height: 27px;
        border-radius: 5px;
      " v-if="displayStatusLabel === false">
      <p style="font-size: 12px; color: #fff">Inactive</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatusComponent",
  props: ["status"],
  data() {
    return {
      statusLabel: this.status,
    };
  },
  computed: {
    displayStatusLabel() {
      return this.statusLabel;
    },
  },
  watch: {
    status: {
      immediate: true,
      handler(newValues) {
        this.statusLabel = newValues;
      },
    },
  },
};
</script>

<style scoped>
</style>